"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var stremio_router_1 = require("stremio-router");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var useCalendarDate_1 = __importDefault(require("../useCalendarDate"));
var Selector_less_1 = __importDefault(require("./Selector.less"));
var Selector = function (_a) {
    var selected = _a.selected, selectable = _a.selectable, profile = _a.profile;
    var toMonth = (0, useCalendarDate_1.default)(profile).toMonth;
    var navigate = (0, react_router_1.useNavigate)();
    var _b = (0, react_1.useMemo)(function () { return ([selectable.prev, selectable.next]); }, [selectable]), prev = _b[0], next = _b[1];
    var onPrev = (0, react_1.useCallback)(function () {
        navigate((0, stremio_router_1.toPath)(prev.deepLinks.calendar));
    }, [prev]);
    var onNext = (0, react_1.useCallback)(function () {
        navigate((0, stremio_router_1.toPath)(next.deepLinks.calendar));
    }, [next]);
    return (react_1.default.createElement("div", { className: Selector_less_1.default['selector'] },
        react_1.default.createElement(components_1.Button, { className: Selector_less_1.default['prev'], onClick: onPrev },
            react_1.default.createElement(react_2.default, { className: Selector_less_1.default['icon'], name: 'chevron-back' }),
            react_1.default.createElement("div", { className: Selector_less_1.default['label'] }, toMonth(prev, 'short'))),
        react_1.default.createElement("div", { className: Selector_less_1.default['selected'] },
            react_1.default.createElement("div", { className: Selector_less_1.default['year'] }, selected === null || selected === void 0 ? void 0 : selected.year),
            react_1.default.createElement("div", { className: Selector_less_1.default['month'] }, toMonth(selected, 'long'))),
        react_1.default.createElement(components_1.Button, { className: Selector_less_1.default['next'], onClick: onNext },
            react_1.default.createElement("div", { className: Selector_less_1.default['label'] }, toMonth(next, 'short')),
            react_1.default.createElement(react_2.default, { className: Selector_less_1.default['icon'], name: 'chevron-forward' }))));
};
exports.default = Selector;
